import QuotingServices from "../../services/QuotingServices";
import vm from '@/main.js'
const state = {
    loadingExternal: false,
    externalRequestInspection: undefined,
    externalElectronicBilling: undefined,
    externalElectronicBillingHistory: undefined
};
const getters = {
    externalRequestInspection: state => {
        return state.externalRequestInspection;
    },
    externalElectronicBilling: state => {
        return state.externalElectronicBilling;
    },
    loadingExternal: state => {
        return state.loadingExternal;
    },
    externalElectronicBillingHistory: state => { 
        return state.externalElectronicBillingHistory
    }
};

const actions = {
    external(context) {
        context.commit("showLoadingIndicator");
        const profile = context.rootGetters.userProfile;
        const agencyId= context.rootGetters.agencyId;
        return QuotingServices.external(profile,agencyId)
            .then(response => {
                if (response.data.error == 0) {          
                    state.externalRequestInspection = response.data.data[0];
                    state.externalElectronicBilling = response.data.data[2];
                    state.externalElectronicBillingHistory = response.data.data[3];

                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingIndicator");
            });
    },
};

const mutations = {
    showLoadingIndicator(state) {
        state.loadingExternal = true;
    },
    hideLoadingIndicator(state) {
        state.loadingExternal = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};